import { render, staticRenderFns } from "./CustomSetting.vue?vue&type=template&id=20dcb558"
import script from "./CustomSetting.vue?vue&type=script&lang=js"
export * from "./CustomSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports